import clsx from 'clsx';
import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';
import React from 'react';

import {SubcomponentsBenefitsSectionElementComponent} from 'lib/api/strapi';

import {Box, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';
import MarkdownContent from 'components/basic-components/MarkdownContent/MarkdownContent';

import styles from './benefitssection.module.scss';

interface IBeneFitsSectionElementProps extends SubcomponentsBenefitsSectionElementComponent {
  borderLeft?: boolean;
  borderBottom?: boolean;
}
export const BenefitsSectionElement = ({
  headline,
  headerLevel,
  icon,
  text,
  borderLeft,
  borderBottom,
}: IBeneFitsSectionElementProps) => {
  const {iconColor, seperatorColor} = useBackgroundStyleConfigs();

  return (
    <Box
      component="section"
      sx={{borderColor: `${seperatorColor} !important`}}
      className={clsx({
        [styles.elementWrapper]: true,
        [styles.borderLeft]: borderLeft,
        [styles.borderBottom]: borderBottom,
      })}
    >
      <div className={styles.headlineWrapper}>
        <Typography component={headerLevel} variant="h3" className={styles.elementHeadline}>
          {headline}
        </Typography>
        <CustomIcon style={{color: iconColor}} className={styles.icon} name={icon} />
      </div>
      {text ? <MarkdownContent className={styles.elementText} content={text} /> : null}
    </Box>
  );
};
